import { render } from "./BaseSelect.vue?vue&type=template&id=19bfcd68"
import script from "./BaseSelect.vue?vue&type=script&lang=js"
export * from "./BaseSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__